<template>
  <div>
    <Comentario
      :data="data"
      :columns="columns"
      :getComentarios="getComentarios"
    />
  </div>
</template>

<script>
import Comentario from "./user/Comentario.vue";
import { mapState, mapActions } from "vuex";
import { formatRole } from "../../../components/tools/utils";
import axios from "axios";
export default {
  data() {
    return {
      data: [],
      columns: [
        "Email",
        "Comentario",
        "Acciones",
      ]
    };
  },
  components: {
    Comentario,
  },
  computed: {
    ...mapState("sesion", ["usuario", "relacionUS"]),
    isAdmin: function() {
      return this.usuario.username === process.env.VUE_APP_USER_ADMIN;
    },
    showTitle: function() {
      const { path } = this.$route;
      if (path.includes("/admin")) return false;
      return true;
    },
  },
  methods: {
    ...mapActions("sesion", ["setData"]),
    establecerRelacion: function() {
      if (!this.usuario) return;
      if (this.usuario.username === process.env.VUE_APP_USER_ADMIN) return;
      const service = this.usuario.servicios.find(
        (s) => s.id === this.$route.params.idServicio
      );

      this.setData({
        idUsuario: this.$route.params.idUsuario,
        idServicio: service.id,
        ministerio: service.ministerio,
        perfil: formatRole(service.rolNombre),
        rolId: service.rolId,
        nombreServicio: service.nombre,
        usuarioServicioId: service.usuarioServicioId,
      });
    },
    getComentarios: async function() {
      try {
        this.data = [];
        const token = localStorage.getItem("userToken");
        let res;
        res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/comentarios`,
          {
            headers: {
              Authorization: `JWT ${token}`,
            },
          }
        );
        console.log(res);
        this.data = res.data;
        this.columns = ["Email", "Comentario", "Acciones"];
        this.showListUsers = true;
      } catch (error) {
        console.log(error.response.data);
      }
    }
  },
  mounted() {
    this.establecerRelacion();
    setTimeout(() => {
      this.getComentarios();
    }, 200);
  },
};
</script>
<style scoped>
.modal-breadcrumb {
  display: flex;
  padding: 10px 0 !important;
}
</style>
